module.exports = __webpack_public_path__ + "static/media/banner-familia-e-tudo-2024.0999ca9f.png";